import { gql } from '@apollo/client';

export const REPORT_STATISTICS = gql`
  query getReportStatistics(
    $organizationId: ID!
    $campaignIds: [ID!]!
    $dateRange: DateRange!
    $startDate: String
    $endDate: String
  ) {
    getReportStatistics(
      organizationId: $organizationId
      campaignIds: $campaignIds
      dateRange: $dateRange
      startDate: $startDate
      endDate: $endDate
    ) {
      platform {
        type
        value
      }
      adProduct {
        type
        value
      }
      publisherBreakdown {
        type
        value
      }
    }
  }
`;
